import { createAction } from 'redux-actions';
import { createRoutine } from 'redux-saga-routines';
import {
  GET_WORKOUT_PROGRAM,
  SET_DATE_RANGE,
  SET_LOCATION,
  SET_SELECTED_EXERCISE,
} from './type';

export const setLocation = createAction(SET_LOCATION);
export const setDateRange = createAction(SET_DATE_RANGE);
export const setSelectedExercise = createAction(SET_SELECTED_EXERCISE);
export const getWorkoutProgram = createRoutine(GET_WORKOUT_PROGRAM);
